export default __webpack_public_path__ + "static/media/Wallet.cd20e620.svg";